const colorClasses = [
  'bg-blue-50 dark:bg-blue-900/20 text-blue-700 dark:text-blue-300 ring-blue-700/10 dark:ring-blue-400/30',
  'bg-green-50 dark:bg-green-900/20 text-green-700 dark:text-green-300 ring-green-700/10 dark:ring-green-400/30',
  'bg-red-50 dark:bg-red-900/20 text-red-700 dark:text-red-300 ring-red-700/10 dark:ring-red-400/30'
];

export const getDepartmentColorClass = (department: string, index: number): string => {
  // Simply use the index to determine the color, cycling through the available colors
  return colorClasses[index % colorClasses.length];
};
